import * as React from 'react';

const RO_MESSAGE = 'ResizeObserver loop';

let refCount = 0;
let restoreConsoleError: (() => void) | null = null;
let onWindowError: ((e: ErrorEvent) => void) | null = null;

function install() {
    onWindowError = (e: ErrorEvent) => {
        if (e.message?.includes(RO_MESSAGE)) {
            e.stopImmediatePropagation();
            const overlay = document.getElementById('webpack-dev-server-client-overlay');
            if (overlay) overlay.style.display = 'none';
        }
    };
    window.addEventListener('error', onWindowError);

    const original = console.error;
    console.error = (...args: unknown[]) => {
        const first = args[0];
        if (typeof first === 'string' && first.includes(RO_MESSAGE)) {
            return;
        }
        original.apply(console, args as Parameters<typeof console.error>);
    };
    restoreConsoleError = () => {
        console.error = original;
    };
}

function uninstall() {
    if (onWindowError) {
        window.removeEventListener('error', onWindowError);
        onWindowError = null;
    }
    restoreConsoleError?.();
    restoreConsoleError = null;
}

/** Benign browser noise from Ant Design Layout/Menu/Table and @ant-design/plots during resize/scroll. */
export function useSuppressResizeObserverLoop() {
    React.useEffect(() => {
        refCount += 1;
        if (refCount === 1) {
            install();
        }
        return () => {
            refCount -= 1;
            if (refCount === 0) {
                uninstall();
            }
        };
    }, []);
}
